import { render, staticRenderFns } from "./chooseUser.vue?vue&type=template&id=60200b66&scoped=true&"
import script from "./chooseUser.vue?vue&type=script&lang=js&"
export * from "./chooseUser.vue?vue&type=script&lang=js&"
import style0 from "./chooseUser.vue?vue&type=style&index=0&id=60200b66&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60200b66",
  null
  
)

export default component.exports